class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    // Session storage key for tracking language choice (same as language-switcher)
    this.SESSION_KEY = 'languageChosen';
  }

  connectedCallback() {
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      inputLang: this.querySelector('input[name="language_code"]'),
    };

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  markLanguageChosen() {
    // Set session storage to prevent showing language modal again this session
    sessionStorage.setItem(this.SESSION_KEY, 'true');
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    this.elements.inputLang.value = event.currentTarget.dataset.lang;

    // Mark that user has actively chosen a language
    this.markLanguageChosen();

    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
